<template>
  <div class="diff-container">
    <div class="diff_price_top priceInfo">
      <div class="subName">平台价格信息</div>
      <div class="topPartItem" v-if="couponAmount">
        <div class="subLeftPart">
          领优惠券
        </div>
        <div class="subRightPart">
          <div class="coupon">券{{ couponAmount }}元</div>
        </div>
      </div>
      <div v-if="getTempOrderInfo.FreightType" class="topPartItem">
        <div class="subLeftPart">
          运费（商品不包邮）
        </div>
        <div class="subRightPart">￥{{ getTempOrderInfo.Freight.toFixed(2) }}</div>
      </div>
      <div class="topPartItem">
        <div class="subLeftPart">
          {{ couponAmount ? '券后付款金额' : '付款金额' }}
        </div>
        <div class="subRightPart">￥{{ productPrice.toFixed(2) }}</div>
      </div>
    </div>
    <div class="container-box">
      <div class="diff_price_top">
        <div class="subName">提交差价反馈</div>
        <p>请在{{ PLATFORM_TYPE_DETAIL[platformType].collectively }}APP与平台价格信息进行核对，选择存在差价的原因反馈：</p>
      </div>
      <div class="diff_price_radio b_fff">
        <sh-radio :options="radioOptions" @change="radioChange" @checkClick="checkClick" class="sh-radio"> </sh-radio>
        <mt-field
          v-show="radioCheckValue === 4"
          label="描述情况"
          type="textarea"
          :rows="otherDiffReason.length > 14 ? '3' : '1'"
          placeholder="请简单描述存在差价的原因"
          :attr="{ maxlength: 50 }"
          @keyup.native="reasonKeyDown"
          @blur.native.capture="reasonKeyBlur"
          v-model="otherDiffReason"
        >
        </mt-field>
      </div>
      <div class="order_from">
        <div class="b_black err-b fs-26">
          <span>有效的差价截图，可有助于我们尽快核实（选填）</span>
          <span class="iconfont icon-sanjiaoxing"></span>
        </div>
        <!-- upload -->
        <div class="weui-cells sub-upload">
          <div class="weui-cell">
            <div class="weui-uploader">
              <div class="weui-uploader__bd">
                <div class="weui-uploader__files">
                  <div class="weui-uploader__input-box">
                    <div class="weui-uploader__input">
                      <input type="file" class="upload-input" accept="image/*" @change="selectImgChange($event)" />
                    </div>
                  </div>
                  <div v-if="isUploading || isUploadFail || uploadImgSrc" class="weui-uploader__file" :class="[isUploading || isUploadFail ? 'weui-uploader__file_status' : '']" @click="previewImage">
                    <img class="weui-uploader__img" v-if="uploadImgSrc" :src="uploadImgSrc" />
                    <div class="weui-uploader__file-content" v-if="isUploading">{{ uploadingProgress }}%</div>
                    <div class="weui-uploader__file-content" v-if="isUploadFail">
                      <i>上传失败</i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 65px"></div>
    <div class="order-btn b_fff flex">
      <div>
        <mt-button class="shCancelBtn" type="default" @click="goBack">取消反馈</mt-button>
      </div>
      <div class="btn-margin">
        <mt-button class="shPrimaryBtn" type="danger" @click="feedbackSubmit" :disabled="btnLoading || btnDisabled">提交反馈 </mt-button>
      </div>
    </div>
    <preview-dialog v-if="previewDialogShow" @close="previewDialogShow = false" :img-src="previewImgSrc" :class="{ 'mode-type': imgModelType }"> </preview-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { IMG_BASE_URL } from '@/config'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'
import ShRadio from '@/components/puppetComponent/ShRadio'
import { UpaiyunUploadInfoGet } from '@/api/order'
import { SpreadFeedbackAdd } from '@/api/feedback'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      radioCheckValue: 0,
      radioOptions: [
        { label: '没有与平台价格一致的商品型号', value: 1 },
        { label: '没有优惠券可以领', value: 2 },
        { label: '商品不包邮', value: 3 },
        { label: '其他', value: 4, hiddenBtn: true }
      ],
      otherDiffReason: '',
      isUploading: false,
      isUploadFail: false,
      uploadingProgress: 0,
      uploadImgSrc: '',
      uploadUserInfo: {},
      taskID: null,
      showRootPath: IMG_BASE_URL,
      // 0:价格一致  1:优惠券  2:包邮
      exampleImgs: ['/upaiyun/Sys/20190308/4627201877403819555.jpg', '/upaiyun/Sys/20190308/5761572469840871545.jpg', '/upaiyun/Sys/20190308/5081096399386348293.jpg'],
      pddExampleImgs: ['/upaiyun/Sys/20200108/5058254743331030356.jpg', '/upaiyun/Sys/20200108/5213299269762793186.jpg', '/upaiyun/Sys/20200108/5728011218991455360.jpg'],
      jdExampleImgs: ['/upaiyun/Sys/20211112/5056146436118424366.jpg', '/upaiyun/Sys/20211112/4887520524687480771.jpg', '/upaiyun/Sys/20211112/4789348197157746682.jpg'],
      dyExampleImgs: ['/upaiyun/Sys/20220104/5334810483720080911.jpg', '/upaiyun/Sys/20220104/4624754462596994890.jpg', '/upaiyun/Sys/20220104/4760580496716341095.jpg'],
      previewImgSrc: '',
      previewDialogShow: false,
      imgModelType: '',
      btnLoading: false,
      btnDisabled: true,
      platformType: 0, // 0: 淘宝, 1: 拼多多
      couponAmount: '',
      productPrice: ''
    }
  },
  computed: {
    ...mapGetters(['getTempOrderInfo'])
  },
  components: {
    PreviewDialog,
    ShRadio
  },
  created() {
    this.taskID = this.getTempOrderInfo.TaskID
    this.productPrice = this.getTempOrderInfo.ProductPrice
    this.couponAmount = this.getTempOrderInfo.CouponAmount
    this.platformType = this.getTempOrderInfo.PlatformType
  },
  mounted() {
    if (this.taskID) {
      this.fetchUploadInfo()
      window.addEventListener('resize', this.inputFocusResize)
    } else {
      Toast('无任务ID')
      this.$router.go(-1)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.inputFocusResize)
  },
  methods: {
    // 获取上传图片信息
    fetchUploadInfo() {
      UpaiyunUploadInfoGet().then((res) => {
        this.uploadUserInfo.uploadUrl = res.UploadUrl
        this.uploadUserInfo.loginName = res.LoginName
        this.uploadUserInfo.password = res.Screct
      })
    },
    // 图片上传
    selectImgChange(event) {
      let _this = this
      let rootPath = this.showRootPath
      let file = event.target.files[0]
      if (file) {
        let data = new FormData()
        data.append('diffPriceFeedbackUpload', file)
        document.querySelector('.upload-input').value = ''
        axios({
          method: 'post',
          url: this.uploadUserInfo.uploadUrl,
          params: {
            loginName: this.uploadUserInfo.loginName,
            secret: this.uploadUserInfo.password
          },
          data: data,
          timeout: 60000,
          onUploadProgress: function(progressEvent) {
            // 显示相应的上传进度
            let percent = (progressEvent.loaded / progressEvent.total) * 100
            _this.uploadingProgress = parseInt(percent)
            _this.isUploading = true
            _this.isUploadFail = false
          }
        })
          .then((res) => {
            if (res.status === 200 && res.data.StatusCode === 200) {
              // 上传成功，展示图片，隐藏进度条
              this.uploadImgSrc = rootPath + res.data.Message
              this.isUploading = false
              this.isUploadFail = false
            } else {
              Toast(res.Message)
              this.uploadingProgress = 0
              this.uploadImgSrc = ''
              this.isUploading = false
              this.isUploadFail = true
            }
          })
          .catch(() => {
            Toast('上传图片失败！请重新上传')
            this.uploadingProgress = 0
            this.uploadImgSrc = ''
            this.isUploading = false
            this.isUploadFail = true
          })
      }
    },
    radioChange(val) {
      this.radioCheckValue = val
      this.btnDisabled = false
      if (val === 0 || (val === 4 && !this.otherDiffReason)) {
        this.btnDisabled = true
      } else {
        this.btnDisabled = false
      }
    },
    inputFocusResize() {
      // 解决问题：微信内置浏览器浏览的H5页面弹出键盘时遮盖文本框
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        window.setTimeout(() => {
          document.activeElement.scrollIntoViewIfNeeded()
        }, 0)
      }
    },
    // 如何查看
    checkClick(index) {
      this.imgModelType = true
      switch (this.platformType) {
        case 1:
          // 京东
          this.previewImgSrc = this.showRootPath + this.jdExampleImgs[index]
          break
        case 2:
          // 拼多多
          this.previewImgSrc = this.showRootPath + this.pddExampleImgs[index]
          break
        case 3:
          // 抖音
          this.previewImgSrc = this.showRootPath + this.dyExampleImgs[index]
          break
        default:
          // 淘宝/天猫
          this.previewImgSrc = this.showRootPath + this.exampleImgs[index]
          break
      }
      this.previewDialogShow = true
    },
    previewImage() {
      this.imgModelType = ''
      this.previewImgSrc = this.uploadImgSrc
      this.previewDialogShow = true
    },
    reasonKeyDown() {
      if (this.otherDiffReason) {
        this.otherDiffReason = this.otherDiffReason.replace(/(^[\r\n\s]*)|([\r\n\s]*$)/g, '')
      }
    },
    reasonKeyBlur() {
      this.reasonKeyDown()
      setTimeout(function() {
        window.scrollTo(0, 0)
      }, 100)
    },
    goBack() {
      this.$router.go(-1)
    },
    // 反馈
    feedbackSubmit() {
      if (!this.taskID) {
        Toast('无任务ID')
        return
      }
      if (this.radioCheckValue === 4 && !this.otherDiffReason) {
        Toast('请输入差价原因')
        return
      }
      if (this.isUploading) {
        Toast('正在上传图片，请稍后再提交')
        return
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.btnLoading = true
      SpreadFeedbackAdd({
        taskId: this.taskID,
        type: this.radioCheckValue - 1,
        auditPicUrl: this.uploadImgSrc,
        remark: this.radioCheckValue === 4 ? this.otherDiffReason : ''
      })
        .then((res) => {
          Indicator.close()
          this.btnLoading = false
          MessageBox({
            title: '提示',
            message: '平台已收到你的反馈。请暂时不要购买，我们会尽快核实后与你联系。',
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            confirmButtonText: '我知道了',
            confirmButtonClass: 't_f23030'
          }).then((action) => {
            if (action === 'confirm') {
              this.$router.replace({
                name: 'order',
                query: {
                  tabIndex: 1
                }
              })
            }
          })
        })
        .catch((err) => {
          Indicator.close()
          this.btnLoading = false
          Toast(err.ErrMsg)
        })
    }
  },
  watch: {
    otherDiffReason() {
      console.log(123)
      if (this.otherDiffReason) {
        this.btnDisabled = false
      } else {
        this.btnDisabled = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import './css/index.scss';
</style>
